/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listJoinRequests.defs.js'
export { main as default } from './listJoinRequests.defs.js'
